import Container from "./VariationProductsListStyle";
import { CentsToHuman } from "../../../utils";

import { FaTrashAlt } from "react-icons/fa";

export default function VariationProductsList({ productId, variations, history, disabled, onClickDeleteVariation }) {

  function GoToVariation(variationId: number) {
    history.push(`/products/${productId}/${variationId}`);
  }

  return (
    <Container className="panel">
      <div id="title">
        <h4>Variações do produto</h4>
        <button className="btn btn-success" disabled={disabled} onClick={e => GoToVariation(0)}>Adicionar</button>
      </div>
      <table className="table table-striped table-bordered table-hover" id="productVariationsForm">
        <thead>
          <tr>
            <th scope="col">Nome</th>
            <th scope="col">Modificador de preço</th>
            <th scope="col">Deletar</th>
          </tr>
        </thead>
        <tbody>
          {variations && variations.length > 0 && variations.map(variation => {
            return (
              <tr className="clickable" key={variation.id}>
                <td onClick={e => GoToVariation(variation.id)} >{variation.name}</td>
                <td onClick={e => GoToVariation(variation.id)} >{CentsToHuman(variation.priceModification)}</td>
                <td className="action">
                  <button
                    onClick={() => onClickDeleteVariation(variation)}
                    disabled={disabled}
                  ><FaTrashAlt className="icon" /></button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </Container >

  );
}